export default __webpack_public_path__ + "static/apple-store-button-d7e33f521b44462df31a3fca2394f467.svg";